import { render, staticRenderFns } from "./clientInfo.vue?vue&type=template&id=1dfb46e4&scoped=true"
import script from "./clientInfo.vue?vue&type=script&lang=js"
export * from "./clientInfo.vue?vue&type=script&lang=js"
import style0 from "./clientInfo.vue?vue&type=style&index=0&id=1dfb46e4&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1dfb46e4",
  null
  
)

export default component.exports